import Button from '@mui/material/Button';
import ReactPopover from '@mui/material/Popover';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

import Popover from '@sophocles/components/Popover';

class PopPdfPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = { popoverAnchorEl: undefined };
    this._onChoice = this._onChoice.bind(this);
  }

  _onChoice(element) {
    this.setState({ popoverAnchorEl: undefined });
    const { onChoice, data } = this.props;
    onChoice(data, element.currentTarget.dataset.id);
  }

  handleClick = e => {
    this.setState({
      popoverAnchorEl: e.currentTarget,
    });
  };

  handleClose = e => {
    this.setState({
      popoverAnchorEl: undefined,
    });
  };

  render() {
    const { relayLoads, isBillboard, t } = this.props;
    const open = Boolean(this.state.popoverAnchorEl);
    const popoverProps = {
      id: this.state.popoverAnchorEl,
      open,
      onClose: () => this.setState({ popoverAnchorEl: undefined }),
      anchorEl: this.state.popoverAnchorEl,
      anchorOrigin: {
        vertical: 'center',
        horizontal: 'right',
      },
      transformOrigin: {
        vertical: 'center',
        horizontal: 'left',
      },
    };
    return (
      <div className="overlay-example" style={{ position: 'relative', display: 'inline-block', marginLeft: '5px' }}>
        <Button
          size="small"
          color="error"
          variant="contained"
          onClick={this.handleClick}
          startIcon={<i className="far fa-file-pdf" />}
        >
          {t('pop.pdf')}
        </Button>

        <ReactPopover {...popoverProps}>
          <Popover>
            <div style={{ color: 'var(--text-secondary)' }}>
              <div style={{ height: '36px', marginBottom: '8px', lineHeight: '18px' }}>
                <span
                  style={{
                    lineHeight: '36px',
                    textAlign: 'center',
                    padding: '0 2pc',
                    margin: '0 10px',
                    borderBottom: '1px solid #8c8c8c',
                    display: 'block',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                  }}
                >
                  {' '}
                  {isBillboard ? t('pop.selectPanel') : t('pop.selectZone')}{' '}
                </span>
                <a
                  href="#"
                  style={{
                    color: 'var(--text-primary)',
                    position: 'absolute',
                    padding: '10px 15px 10px 4px',
                    top: 0,
                    right: 0,
                  }}
                  onClick={this.handleClose}
                >
                  <i className="far fa-window-close" style={{ color: 'var(--text-secondary)' }} />
                </a>
              </div>
              <div>
                <div style={{ padding: '0 30px 10px 30px', display: 'block' }}>
                  {isBillboard ? t('pop.panelsNote') : t('pop.zonesNote')}
                </div>
                <div style={{ padding: '0 10px 10px 10px', display: 'block' }}>
                  <div>
                    {relayLoads.map(load => (
                      <p key={load.get('id')} style={{ marginBottom: '.2rem' }}>
                        <a data-id={load.get('id')} href="#" onClick={this._onChoice}>
                          {load.get('name')}
                        </a>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </ReactPopover>
      </div>
    );
  }
}

PopPdfPopover.propTypes = {
  relayLoads: PropTypes.object,
  onChoice: PropTypes.func,
  data: PropTypes.object,
  isBillboard: PropTypes.bool,
};

export default withTranslation()(PopPdfPopover);
